import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ApiResult, ILookup } from 'src/app/shared/model/Index';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { Messages } from '@app/modules/compliance/constants/messages';
import { IStudent } from '@app/modules/compliance/model/student';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { IPersonEmail } from '../../model/personemail';
import { emptyPersonEmail } from '@app/modules/compliance/constants/prepareEmptyObject';
import { LookupService } from '@app/modules/maintenance/services/lookup.service';
import { ELookup } from '@app/modules/compliance/constants/eLookup';
import { PersonEmailService } from '../../services/personemail.service';
import { Guid } from 'guid-typescript';
import { environment as env } from '@environments/environment'

@Component({
    selector: 'app-personemail',
    templateUrl: './person-email.component.html',
    styleUrls: ['./person-email.component.css'],
})

export class PersonEmail implements OnInit {
    @Input() student: IStudent;
    @Input() WriteAction:boolean = false;
    isShown: boolean = false;
    displayedColumns: string[] = ['emailType', 'email'];
    dataSource = new MatTableDataSource<IPersonEmail>();
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    public emailFormGroup: UntypedFormGroup;
    public personEmail: IPersonEmail = emptyPersonEmail();
    public emailTypeList: ILookup[];
    emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _lookupservice: LookupService,
        private _snackBar: MatSnackBar,
        private _personEmailservice: PersonEmailService) { }
    ngOnInit() {
        this.getActiveLookups(ELookup.EmailType);
        this.get();
    }
    cancel() {
        this.personEmail = emptyPersonEmail();
        this.fillForm(this.personEmail);
        this.isShown = false;
    }
    add() {
        this.personEmail = emptyPersonEmail();
        this.fillForm(this.personEmail);
        this.isShown = true;
    }
    edit(personEmail: IPersonEmail) {
        this.personEmail = personEmail;
        this.isShown = true;
        this.fillForm(this.personEmail);
    }
    delete(id: Guid) {
        this.deleteAddressById(id);
        this.cancel();
    }
    private getActiveLookups(tableName: string) {
        this._lookupservice.getActiveLookups(tableName).subscribe((result: ApiResult<ILookup[]>) => {
            if (result.validationErrors == null) {
                switch (tableName) {
                    case ELookup.EmailType:
                        this.emailTypeList = result.value;
                        break;
                    default:
                        break;
                }
            }
        }, error => console.error(error));
    }
    public get() {
        this._personEmailservice.get(this.student.personId).subscribe((result: ApiResult<IPersonEmail[]>) => {
            if (result.validationErrors == null && result.value != null) {
                this.dataSource = new MatTableDataSource<IPersonEmail>(result.value);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
        }, error => console.error(error));
    }
    private deleteAddressById(id: Guid) {
        this._personEmailservice.delete(id).subscribe((result: ApiResult<any>) => {
            if (result.validationErrors == null) {
                this.get()
            }
        }, error => console.error(error));
    }
    private fillForm(PersonEmail: IPersonEmail) {
        this.emailFormGroup = this._formBuilder.group(
            {
                personId: [PersonEmail.personId],
                tenantId: [PersonEmail.tenantId],
                personEmailId: [PersonEmail.personEmailId],
                emailTypeId: [PersonEmail.emailTypeId],
                email: [PersonEmail.email],
            });
    }
    public onSubmit() {
        this.personEmail = this.emailFormGroup.value as IPersonEmail;
        if (this.personEmail.personEmailId !== null) {
            this._personEmailservice.put(this.personEmail).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.notify();
                    this.get();
                }
                else {
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
        else {
            this.personEmail.personId = this.student.personId;
            this.personEmail.tenantId = Guid.parse(env.tenantId).toJSON().value;
            this.personEmail.personEmailId = Guid.createEmpty().toJSON().value;
            this._personEmailservice.post(this.personEmail).subscribe((result: ApiResult<number>) => {
                if (result.statusCode == 200) {
                    this.cancel();
                    this.notify();
                    this.get();
                }
                else {
                    this.personEmail.personEmailId = null;
                    this.notifyWarnings(result.validationErrors);
                }
            }, error => console.error(error));
        }
    }
    notifyWarnings(message: string[]) {
        let snackBarRef = this._snackBar.open(message[0], "Close", {
            duration: 5000,
            panelClass: ['red-snackbar']
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }
    notify() {
        let snackBarRef = this._snackBar.open(Messages.EmailSaved, "Close", {
            duration: 2000,
        });
        snackBarRef.afterDismissed().subscribe(() => {
        });
    }

    evalBind(data:ILookup,currentValue:number){
        if(data.id==currentValue){
            return true;
        }
      return !data.disabled;
    }
}